import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfigService } from './core/config/app-config.service';
import { FooterComponent } from './core/layout/footer/footer.component';
import { HeaderComponent } from './core/layout/header/header.component';
import { LayoutComponent } from './core/layout/layout.component';
import { CommonControlService } from './core/services/common-control.service';
import { ViewerModule } from './modules/fileviewer/viewer.module';
import { ViewerControlInfoService } from './modules/fileviewer/pages/viewer/viewer-control-info';
import {ResultControlInfoService} from './modules/fileviewer/pages/result/result-control-info';
import { SearchFieldsControlInfoService } from './modules/fileviewer/pages/search-fields/search-fields-control-info';
import { DetailViewerInfoService } from './modules/fileviewer/pages/detail-viewer/detail-viewer-info';
import {ViewerService} from './services/viewer-service';
import { NgxDocViewerModule } from 'ngx-doc-viewer'; 



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LayoutComponent
  ],
  imports: [
    BrowserModule,
    ViewerModule,
    HttpClientModule,
    AppRoutingModule,
    ModalModule.forRoot(),
    NgxSpinnerModule,
   BrowserAnimationsModule,
   NgxDocViewerModule
  ],
  providers: [BsModalService,BsModalRef, DatePipe,CommonControlService,ViewerControlInfoService,SearchFieldsControlInfoService,DetailViewerInfoService,ViewerService,ResultControlInfoService,
    AppConfigService, { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfigService], multi: true}],
bootstrap: [AppComponent]
})
export class AppModule { }
export function initializeApp(appConfigService: AppConfigService) {
  return (): Promise<any> => { 
    
    return appConfigService.load();
  }
}